<template>
  <div>
    <el-form inline :model="searchForm">
      <el-form-item>
        <dict-type-select v-model="searchForm.type" placeholder="类型" @change="getRows()" clearable></dict-type-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.keyword" placeholder="名称/编号" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :loading="searching" @click="getRows()">查询</el-button>
        <el-button icon="el-icon-plus" @click="add()">新建</el-button>
      </el-form-item>
    </el-form>
    <jbf-table v-loading="searching" :columns="columns" :data="rows" @sort-change="handleSortChange"
               :page-size.sync="pageSize"
               :total="total"
               :current-page.sync="pageNumber"
               @size-change="handleSizeChange"
               @page-change="handleCurrentChange">
      <template slot="operation" slot-scope="scope">
        <span v-show="scope.row.editable" class="btn-text btn-warning" @click="edit(scope)">修改</span>
        <span v-show="scope.row.editable" class="btn-text btn-danger" @click="remove(scope)">删除</span>
      </template>
    </jbf-table>
    <el-dialog :title="editTitle" :visible.sync="editVisible">
      <el-form ref="editForm" label-width="120px" :model="editForm" :rules="editRules">
        <el-form-item label="类型" prop="type">
          <dict-type-select v-model="editForm.type" clearable/>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="编码" prop="code">
          <el-input-number v-model="editForm.code" :readonly="editTitle==='修改'"></el-input-number>
        </el-form-item>
        <el-form-item label="英文名称" prop="nameEn">
          <el-input v-model="editForm.nameEn"></el-input>
        </el-form-item>
        <el-form-item label="显示顺序" prop="color">
          <el-input-number :min="1" v-model="editForm.sort"></el-input-number>
        </el-form-item>
        <el-form-item label="编辑" prop="color">
          <el-radio-group v-model="editForm.editable">
            <el-radio :label="1">允许</el-radio>
            <el-radio :label="0">禁止</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-folder" @click="save(true)" :loading="editSaving">保存</el-button>
          <!--          <el-button icon="el-icon-folder" @click="save(false)">保存并继续添加</el-button>-->
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import BasePage from "@/components/BasePage";
import {dictDelete, dictInsert, dictList, dictUpdate} from "@/api/remote";
import DictTypeSelect from "components/form/DictTypeSelect";

export default {
  name: "standardItem",
  components: {DictTypeSelect},
  mixins: [BasePage],
  data() {
    return {
      searching: false,
      searchForm: {
        keyword: null,
        type: null,
      },
      rows: [],
      columns: [
        {type: 'index', index: this.indexMethod},
        {label: '类型', prop: 'type', show: true, sortable: 'custom'},
        {label: '名称', prop: 'name', show: true},
        {label: '编码', prop: 'code', show: true, sortable: 'custom'},
        {label: '英文名称', prop: 'nameEn', show: true},
        {prop: 'operation', width: '165px', align: 'center'},
      ],
      editVisible: false,
      editSaving: false,
      editTitle: '新增',
      editItem: null,
      editForm: {
        type: null,
        code: null,
        name: null,
        nameEn: null,
        color: null,
        sort: 1,
        editable: 1,
      },
      editRules: {
        type: [
          {required: true, trigger: 'change', message: '请输入类型'}
        ],
        code: [
          {required: true, trigger: 'change', message: '请输入编码'}
        ],
        name: [
          {required: true, trigger: 'change', message: '请输入名称'}
        ],
      },
      maxCode: null,
    }
  },
  methods: {
    getRows(pageNumber, pageSize) {
      this.searching = true;
      this.pageNumber = pageNumber || 1;
      this.pageSize = pageSize || this.pageSize;
      let form = {
        ...this.searchForm,
        pageNum: this.pageNumber,
        pageSize: this.pageSize,
        orderBy: this.orderBy,
      };
      dictList(form).then(res => {
        this.total = res.total;
        this.rows = res.data;
        this.searching = false;
      }, () => {
        this.searching = false;
      })
    },
    add() {
      this.editForm = {
        type: null,
        code: null,
        name: null,
        nameEn: null,
        color: null,
        sort: 1,
        editable: 1,
      };
      this.editTitle = '新增';
      this.editVisible = true;
    },
    edit({row}) {
      this.editItem = row;
      this.editForm = {...row};
      this.editTitle = '修改';
      this.editVisible = true;
    },
    remove({row, store}) {
      this.$confirm(`确定删除${row.name}?`).then(() => {
        dictDelete({code: row.code, type: row.type}).then(res => {
          this.getRows();
          this.$message.success('删除成功');
        })
      });
    },
    save(close) {
      this.$refs.editForm.validate().then(() => {
        if (this.editTitle === '修改') {
          this.editSaving = true;
          dictUpdate(this.editForm).then(res => {
            this.getRows();
            this.$message.success('修改成功');
            this.editSaving = false;
            this.editVisible = false;
          }, () => this.editSaving = false)
        } else {
          this.editSaving = true;
          dictInsert(this.editForm).then(res => {
            this.getRows();
            this.$message.success('创建成功');
            this.editSaving = false;
            // 是否关闭弹出框
            if (close) {
              this.editVisible = false;
            } else {
              this.editForm = form;
            }
          }, () => this.editSaving = false)
        }
      });
    },
  },
  mounted() {
    this.getRows();
  }
}
</script>

<style scoped>

</style>
